<template>
  <v-container>
    <v-card>
      <v-card-title>
        Team Directory
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :items-per-page="25"
        :search="search"
        sort-by="username"
      ></v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      search: '',
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Username', value: 'username' },
        { text: 'Connection to Team', value: 'connection' },
      ],
    }
  },
  computed: {
    users: function () {
      return this.$store.getters['users/getAll']()
    },
  },
  mounted: function () {
    this.$store.dispatch('users/bindUsers')
  },
}
</script>
